import {
    CoreOrder,
    CoreOrdersGridOutput,
    fromCoreOrderNames,
    GridOutput,
    Order,
    OrderProduct,
    CoreOrderPayload,
} from 'skladon-types';

import { OrdersMapper } from '../OrdersMapper';
import { CoreGridMapper } from '../CoreGridMapper';
import { toInt, toNumber } from '../numbers';
import { asInt } from './coerceNumbers';

type OrderProductV21 = Omit<OrderProduct, 'locationId' | 'count' | 'productPrice' | 'missingCount' | 'confirmed'> & {
    count: number | null;
    productPrice: number | null;
    missingCount?: number | null;
    confirmed?: number | null;
};
type OrderV21Response = Omit<
    Order,
    | 'recipientAddressAdditionalInfo2'
    | 'billingAddressAdditionalInfo2'
    | 'orderProducts'
    | 'price'
    | 'shippingPrice'
    | 'codPrice'
> & {
    price: number | null;
    shippingPrice: number | null;
    codPrice: number | null;
    orderProducts?: OrderProductV21[];
};

export class OrdersMapperV21 {
    public static fromCore(coreOrder: CoreOrder): OrderV21Response {
        const base = OrdersMapper.fromCore(coreOrder);
        const {
            recipientAddressAdditionalInfo2,
            billingAddressAdditionalInfo2,
            orderProducts,
            price,
            shippingPrice,
            codPrice,
            ...rest
        } = base;
        return {
            ...rest,
            price: toNumber(price),
            shippingPrice: toNumber(shippingPrice),
            codPrice: toNumber(codPrice),
            orderBoxCount: asInt(rest.orderBoxCount),
            orderProducts: orderProducts?.map(({ locationId, count, productPrice, missingCount, confirmed, ...p }) => {
                void locationId;
                return {
                    ...p,
                    count: toInt(count),
                    productPrice: toNumber(productPrice),
                    missingCount: toInt(missingCount),
                    confirmed: asInt(confirmed),
                };
            })
        };
    }

    public static toCore(order: Partial<Order>): CoreOrderPayload {
        return OrdersMapper.toCore(order);
    }

    public static fromCoreGrid(grid: CoreOrdersGridOutput): GridOutput {
        return {
            data: grid.data
                .map((coreOrder) => OrdersMapperV21.fromCore(coreOrder))
                .map((order) => CoreGridMapper.omitColumns(order, fromCoreOrderNames, grid.request.columns)),
            request: CoreGridMapper.mapGrid(grid.request, fromCoreOrderNames, 1000),
            totalCount: grid.totalCount,
        };
    }

    public static toCoreGrid = OrdersMapper.toCoreGrid;
    public static splitSerialNumber = OrdersMapper.splitSerialNumber;
    public static getPackingListsBySku = OrdersMapper.getPackingListsBySku;
    public static addPackingListsToOrderProducts = OrdersMapper.addPackingListsToOrderProducts;
    public static addPackingListsToOrder = OrdersMapper.addPackingListsToOrder;
}
